const module = {
  config: {
    name: 'dashboard',
    icon: 'ri-dashboard-3-line',
    desc: 'PMIS Infrastruktur II',
    layout: true
  },
  routes: [
    // () => import('./users.vue')
    { name: 'project-control', label: 'Project Control', icon: null, path: '/project-control', component: () => import('./project-control.vue') },
    // { name: 'presentation-pages', label: null, hidden: true, icon: null, path: '/presentation-pages', component: () => import('./project-control-carousel.vue') },
    { name: 'cctv', label: 'CCTV', icon: null, path: '/cctv', component: () => import('./dashboard-cctv.vue') },
    { name: 'monitoring', label: 'Monitoring Submission', icon: null, path: '/dashboard-monitoring', component: () => import('./dashboard-monitoring.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/dashboard/_index.js